<template>
  <sb-panel
    class="sb-crosssell"
    heading="Often bought together"
    collection="crosssell"
    v-if="enabled && crosssellEnabled"
  >
    <sb-products
      errorMessage="No previous products found!"
      :products="crosssellProducts || []"
      collection="crosssell"
      :collectionPage="crosssellProductsPage"
      @toggleProducts="toggleCrosssell"
      @toggleSimilar="toggleSimilar"
      v-if="crosssellOpen"
    ></sb-products>
  </sb-panel>
</template>

<script>
import sbPanel from "./partials/Panel.vue";
import sbProducts from "./partials/ProductGrid.vue";
import { mapState } from "vuex";

export default {
  props: {
    cid: { type: String },
    enabled: { type: Boolean },
  },
  computed: mapState([
    "crosssellProductsPage",
    "crosssellProducts",
    "crosssellOpen",
    "crosssellEnabled",
    "cart",
  ]),
  components: {
    sbPanel,
    sbProducts,
  },
  methods: {
    toggleCrosssell(payload) {
      const toggle = payload ? payload.toggle : true;
      const force = payload ? payload.force : false;
      const reset = payload ? payload.reset : false;

      const data = {
        productList: this.cart,
        site: this.cid,
        numProducts: 3,
        page: payload.page,
      };
      const headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        clientID: this.cid,
      };
      this.$store.dispatch("fetchProducts", {
        toggle: toggle,
        force: force,
        reset: reset,
        panel: "crosssell",
        data: data,
        headers: headers,
      });
      // this.$emit("toggleCrosssell", {
      //   toggle: false,
      //   reset: false,
      //   page: payload.page,
      //   cart: this.cart,
      // });
    },
    toggleSimilar(payload) {
      this.$emit("toggleSimilar", {
        sku: payload.sku,
        page: 1,
        reset: true,
        toggle: true,
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
#shopbox .sb-crossell {
  min-width: 200px;
  min-height: 100px;
}
</style>
